// components/Journey/JourneyContainer.tsx
import React from "react";
import { useJourney } from "./JourneyProvider";
import CpfScreen from "./CpfScreen";
import LocationScreen from "./LocationScreen";
import FaceScreen from "./FaceScreen";
import DocumentScreen from "./DocumentScreen";
import * as FaIcons from "react-icons/fa";
import FinishScreen from "./FinishScreen";

export const JourneyContainer: React.FC = () => {
  const { styles, step, next, isLoading, previous } = useJourney();

  const FaChevronLeftIcon = FaIcons.FaChevronLeft as unknown as React.FC<
    React.SVGProps<SVGSVGElement>
  >;

  const render = () => {
    console.log("step", step);
    switch (step) {
      case "location":
        return <LocationScreen styles={styles} onNext={next} />;
      case "face":
        return <FaceScreen styles={styles} onNext={next} />;
      case "document":
        return <DocumentScreen styles={styles} onNext={next} />;
      case "cpf":
        return <CpfScreen />;
      case "finish":
        return <FinishScreen />;
      default:
        return <FinishScreen />;
    }
  };

  if (isLoading) {
    return (
      <div
        style={{
          width: "100%",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#fff",
        }}
      >
        <p style={{ fontSize: 18, color: "#888" }}>Carregando jornada...</p>
      </div>
    );
  }

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        padding: "40px 24px",
        boxSizing: "border-box",

        alignItems: "center",
        justifyContent: "flex-start",

        backgroundColor: styles.backgroundColor,
        color: styles.textColor,
      }}
    >
      {!(step === "cpf") && (
        <button
          onClick={previous}
          style={{
            position: "absolute",
            top: 24,
            left: 24,
            background: "transparent",
            border: "none",
            padding: 4,
            cursor: "pointer",
          }}
          aria-label="Voltar"
        >
          <FaChevronLeftIcon color={styles.textColor} />
        </button>
      )}

      {styles.logoUrl && (
        <img
          src={styles.logoUrl}
          alt="Logo"
          style={{ maxHeight: 70, objectFit: "contain", marginBottom: 24 }}
        />
      )}

      <div
        style={{
          width: "100%",
          maxWidth: 480,
          display: "flex",
          flexDirection: "column",
          gap: 24,
        }}
      >
        {render()}
      </div>
    </div>
  );
};
